export default __webpack_public_path__ + "img/376f9134da0244bfc4705caf1b944d3a.png";